import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-void text-ghost flex items-center justify-center scanlines px-6 grain" data-testid="not-found-page">
            <div className="max-w-xl w-full border border-border bg-black/60 backdrop-blur-xl">
                <div className="px-4 py-2 border-b border-border bg-black/40 flex items-center justify-between">
                    <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-signal">apib://signal_not_found</span>
                    <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-muted">err.404</span>
                </div>
                <div className="p-10">
                    <div className="font-display text-7xl sm:text-8xl font-black tracking-tighter uppercase text-signal glow-amber">404</div>
                    <div className="mt-4 font-mono text-sm text-muted">
                        This path is not registered with the autonomous fabric. The signal you followed terminated outside the backbone.
                    </div>
                    <div className="mt-8 flex flex-col sm:flex-row gap-3">
                        <Link to="/" data-testid="not-found-home" className="inline-flex items-center gap-2 px-5 py-3 bg-signal text-void font-mono uppercase tracking-[0.2em] text-xs hover:bg-signal-soft">
                            Return to the Backbone
                        </Link>
                        <Link to="/admin/login" className="inline-flex items-center gap-2 px-5 py-3 border border-border text-ghost font-mono uppercase tracking-[0.2em] text-xs hover:border-signal hover:text-signal transition-colors">
                            Admin Console
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
